import React from "react";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";

import { Weight } from "../../types/weights";
import { getWeighValue } from "../../utils/collectionPoints/getWeighValue";
import { PercentChangeTag } from "../PercentChangeTag";

import styles from "./TableWeightCell.module.scss";

interface ITableWeightCellProps {
  params: GridRenderCellParams<number>;
  percentChange?: number;
  reverseNegativeColors?: boolean;
}

export const TableWeightCell: React.FC<ITableWeightCellProps> = ({ params, percentChange, reverseNegativeColors }) => {
  const weight = params.value ?? 0;
  const weightDisplay = getWeighValue(true, weight, Weight.Kg, 2);

  return (
    <p className={styles.container}>
      {weightDisplay}
      {percentChange !== undefined && (
        <PercentChangeTag value={percentChange} reverseNegativeColors={reverseNegativeColors} />
      )}
    </p>
  );
};
